<template>
    <!-- 基本资料 -->
    <div class="basic-data">
        <el-form
            size="mini"
            label-width="300px"
            label-position="left"
            class="basic-data-form"
            ref="basicDataForm"
            :model="form"
            :rules="rules">
            <!-- 头像 -->
            <el-form-item label="头像 / Avatar">
                <el-upload
                    class="avatar-uploader"
                    :action="API.user.avatar"
                    :http-request="handleRequest"
                    accept=".jpg,.jpeg,.png,.webp,image/jpeg,image/png,image/webp"
                    :show-file-list="false">
                    <div class="avatar_box">
                        <img v-if="basic_data.head" :src="basic_data.head">
                        <img v-else :src="require('@/assets/images/avatar-default.png')">
                    </div>
                </el-upload>
                <span class="change_btn avatar_tips">点击头像进行修改</span>
            </el-form-item>
            <!-- 昵称 -->
            <el-form-item label="昵称 / Nickname">
                <el-input
                    v-model="form.nickname"
                    class="center_basic_data_setbox"
                    clearable>
                </el-input>
            </el-form-item>
            <!-- 所在城市 -->
            <el-form-item label="所在城市 / City">
                <area-cascader 
                    v-model="form.city"
                    type='text'
                    :level='1'
                    :data="$pcaa"
                    placeholder="请选择地址"
                    class="center_basic_data_set_city">
                </area-cascader>
            </el-form-item>
            <!-- 详细地址 -->
            <el-form-item label="详细地址 / Address">
                <el-input
                    v-model="form.address"
                    class="center_basic_data_setbox"
                    clearable>
                </el-input>
            </el-form-item>
            <!-- 生日 -->
            <el-form-item label="生日 / Birthday">
                <el-date-picker
                    v-model="form.born"
                    value-format="yyyy-MM-dd"
                    class="center_basic_data_setbox"
                    type="date">
                </el-date-picker>
            </el-form-item>
            <!-- 性别 -->
            <el-form-item label="性别 / Gender">
                <el-radio v-model="form.sex" :label="0">女</el-radio>
                <el-radio v-model="form.sex" :label="1">男</el-radio>
            </el-form-item>
            <!-- 手机号码 -->
            <!-- <el-form-item label="手机号码 / Phone">
                <el-input
                    v-model="form.phone"
                    class="center_basic_data_setbox"
                    clearable>
                </el-input>
            </el-form-item> -->
            <!-- 电子邮箱 -->
            <el-form-item label="电子邮箱 / Email" prop="email">
                <el-input
                    v-model="form.email"
                    class="center_basic_data_setbox"
                    clearable>
                </el-input>
            </el-form-item>
            <!-- 微信 -->
            <el-form-item label="微信 / WeChat">
                <el-input
                    v-model="form.wechat"
                    class="center_basic_data_setbox"
                    clearable>
                </el-input>
            </el-form-item>
            <!-- QQ -->
            <el-form-item label="QQ">
                <el-input
                    v-model="form.qq"
                    class="center_basic_data_setbox"
                    clearable>
                </el-input>
            </el-form-item>
        </el-form>
        <!-- 收款信息 -->
        <div class="basic-receipt-title">收款信息</div>
        <ul class="basic-receipt-list">
            <li>
                <div class="basic-receipt-list-title">微信</div>
                <div class="basic-receipt-list-input">
                    <label>账号</label>
                    <el-input
                        v-model="form.a_wechat"
                        size="mini"
                        disabled
                        class="center_basic_data_setbox">
                    </el-input>
                </div>
            </li>
            <li>
                <div class="basic-receipt-list-title">支付宝</div>
                <div class="basic-receipt-list-input">
                    <label>账号</label>
                    <el-input
                        v-model="form.a_alipay"
                        size="mini"
                        disabled
                        class="center_basic_data_setbox">
                    </el-input>
                </div>
            </li>
            <li>
                <div class="basic-receipt-list-title">银行卡</div>
                <div class="basic-receipt-list-input">
                    <label>户名</label>
                    <el-input
                        v-model="form.a_name"
                        size="mini"
                        disabled
                        class="center_basic_data_setbox">
                    </el-input>
                </div>
                <div class="basic-receipt-list-input">
                    <label>卡号</label>
                    <el-input
                        v-model="form.a_card"
                        size="mini"
                        disabled
                        class="center_basic_data_setbox">
                    </el-input>
                </div>
                <div class="basic-receipt-list-input">
                    <label>开户行</label>
                    <el-input
                        v-model="form.a_bank"
                        size="mini"
                        disabled
                        class="center_basic_data_setbox">
                    </el-input>
                </div>
            </li>
        </ul>
        <!-- 提交区域 -->
        <div style="margin-top:70px">
            <el-button 
                type="warning"
                @click="handleSubmit"
                class="give_up_btn">
                <span>保存</span>
            </el-button>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import API from '@/tool/api';
import { getAvatarFileError } from '@/tool/avatarSubmission.cjs';

export default {
    data(){
        return {
            API,
            form: {
                nickname: "",
                city: [],
                address: "",
                born: "",
                sex: "",
                phone: "",
                email: "",
                wechat: "",
                qq: "",
                a_wechat: "",
                a_alipay: "",
                a_name: "",
                a_card: "",
                a_bank: "",
            },
            rules: {
                email: [{
                    type: "email",
                    message: "请输入正确的邮箱地址",
                    trigger: "blur",
                }],
            }
        }
    },
    computed: mapState({
        basic_data: state => state.user.basic_data,
        basic_data_error: state => state.user.basic_data_error,
        user_id: state => state.user.user_id,
    }),
    methods: {
        ...mapMutations([
            "setAvatar",
            "setBasicData"
        ]),
        ...mapActions([
            "getBasicData",
            "handleChangeBasic",
            "handleChangeAvatar"
        ]),
        handleRequest(val){
            const error = getAvatarFileError(val.file);
            if (error) {
                this.$message.error(error);
                return ;
            }
            this.submitAvatar(val.file);
        },
        submitAvatar(avatar){
            this.handleChangeAvatar(avatar).then((res) => {
                this.$message({
                    showClose: true,
                    message: res.msg,
                    type: res.type,
                });
            }).catch(() => {})
        },
        filterTime(value){
            let time = new Date(value),
            y = time.getFullYear();
            // m = time.getMonth
        },
        setForm(basic){
            this.form = {
                nickname: basic.nickname,
                city: [basic.province, basic.city, basic.area].filter(Boolean),
                address: basic.address,
                born: basic.born,
                sex: basic.sex,
                phone: basic.phone,
                email: basic.email,
                wechat: basic.wechat || "",
                qq: basic.qq || "",
                a_wechat: basic.aWechat || "",
                a_alipay: basic.aAlipay || "",
                a_name: basic.aName || "",
                a_card: basic.aCard || "",
                a_bank: basic.aBank || ""
            }
        },
        handleSubmit(){
            this.$refs.basicDataForm.validate((valid) => {
                if (!valid) {
                    this.$message.error("请检查基本资料填写");
                    return;
                }
                this.handleChangeBasic({
                    nickname: this.form.nickname,
                    city: this.form.city,
                    address: this.form.address,
                    born: this.form.born,
                    sex: this.form.sex,
                    email: this.form.email,
                    wechat: this.form.wechat,
                    qq: this.form.qq,
                }).then((res) => {
                    this.$alert(res.msg, '提示', {
                        confirmButtonText: '确定'
                    });
                })
            });
        }
    },
    watch: {
        basic_data: {
            handler: "setForm",
            immediate: true
        },
        basic_data_error(message){
            if (message) {
                this.$message.error(message);
            }
        }
    },
    mounted(){
        if (this.basic_data_error) {
            this.$message.error(this.basic_data_error);
        }
    },
}
</script>

<style scoped>
/* element-ui */
.basic-data-form>>>.el-form-item__label{
    color: #909399;
}

.basic-data{
    padding: 20px 100px;
}
/* 头像 */
.avatar-uploader{
    display: inline-block;
    vertical-align: text-bottom;
    height: 52px;
}
.avatar-uploader>>>.el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader>>>.el-upload:hover {
    border-color: #409EFF;
}
.avatar_box{
    position: relative;
    width: 50px;
    height: 50px;
}
.avatar_box::before{
    display: block;
    content: "";
    padding-top: 100%;
}
.avatar_box>img{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 100%;
    max-height: 100%;
}
/* 头像提示 */
.avatar_tips{
    float: right;
    line-height: 50px;
    color: #C0C4CC;
}
/* 输入框 */
.center_basic_data_setbox{
    width: 200px
}
/* 所在城市组件 */
.center_basic_data_set_city>>>.area-select{
    width: 200px;
    height: 28px;
}
.center_basic_data_set_city>>>.area-selected-trigger{
    padding: 0 20px 0 12px;
}
/* 收款信息标题 */
.basic-receipt-title{
    padding-bottom: 10px;
    border-bottom: 1px solid #E4E7ED;
    font-size: 25px;
    font-weight: bold;
    color: #303133;
}
/* 收款信息列表 */
.basic-receipt-list{
    padding: 20px 0;
    list-style: disc;
}
.basic-receipt-list>li{
    margin-bottom: 18px;
}
.basic-receipt-list-title{
    font-size: 16px;
    font-weight: bold;
    color: #606266;
}
.basic-receipt-list-input + .basic-receipt-list-input{
    margin-top: 10px;
}
.basic-receipt-list-input > label{
    width: 300px;
    color: #909399;
}
/* 上传按钮 */
.give_up_btn{
    width: 100px;
}
</style>
